<script setup>
    // Vue
    import { defineExpose, ref } from 'vue';

    // Else
    import i18n from '@/common/i18n';

    // let isDisplay = false // メッセージを画面に描画しているか判定するフラグ。
    const messageList = ref([]); // 表示対象の格納されているメッセージの一覧。
    const timeOutList = ref({}); // 時間経過後に非表示になるメッセージの一覧。

    function show(type, message) {
        // 表示中のメッセージが一意になるように、乱数を生成する。
        const messageId = '_' + Math.random().toString(36).substr(2, 9);

        // 表示対象のメッセージのタイトル部。
        let title = '';

        // 表示対象のメッセージの「type」に応じてタイトル部にテキストを設定する。
        switch (type) {
            case 'success':
                // 完了しました
                title = i18n.global.t('common.parts.messageTitleSuccess');
                break;
            case 'unpaid':
                // 決済が完了していません
                title = i18n.global.t('common.parts.messageTitleUnpaid');
                break;
            case 'error':
            default:
                // エラーが発生しました
                title = i18n.global.t('common.parts.messageTitleError');
                break;
        }

        // 画面に表示するメッセージのオブジェクト要素。
        const field = {
            id: messageId,
            messageType: type,
            message: message,
            title: title,
        };

        // 対象のメッセージと同一のメッセージが存在するか判定する。
        const priviousIndex = messageList.value.findIndex((el) => el.message === message && el.title === title);

        // 表示されていないメッセージの場合は、画面描画する。
        if (priviousIndex == -1) {
            // 配列に代入。
            messageList.value.unshift(field);

            // タイマーインスタンスを初期化。
            let timeout = null;

            // タイマーインスタンスに処理を記述し、10秒で非表示になるように設定。
            timeout = setTimeout(() => {
                const index = messageList.value.findIndex((el) => el.id === messageId);
                messageList.value.splice(index, 1);

                delete timeOutList[messageId];
            }, 10000);

            // タイマーイベントを起動。表示中のメッセージの配列に代入して監視する。
            timeOutList[messageId] = timeout;
        }
    }

    function closeMessage(index, id) {
        // ×ボタンをクリックしたメッセージのIDを表示中のメッセージ配列から取得して、タイマーを停止する。
        clearTimeout(timeOutList[id]);

        // ×ボタンをクリックしたメッセージのIDを表示中のメッセージ配列から削除する。
        delete timeOutList[id];

        // 大本のメッセージ一覧配列からも削除する。
        messageList.value.splice(index, 1);
    }

    defineExpose({
        show,
    });
</script>

<template>
    <div class="message-field-wrapper">
        <transition-group name="list">
            <div :class="['message-field', data.messageType]" v-for="(data, index) in messageList" :key="data.id">
                <div class="message-field__left">
                    <div class="icon">
                        <img v-if="data.messageType === 'success'" src="../public/img/base-message-field/checked.svg" />
                        <img v-else-if="data.messageType === 'error' || data.messageType === 'unpaid'" src="../public/img/base-message-field/error.svg" />
                    </div>
                    <div class="content">
                        <div class="title">{{ data.title }}</div>
                        <div class="message">{{ data.message }}</div>
                    </div>
                </div>
                <div class="message-field__right">
                    <div class="icon-close" @click="closeMessage(index, data.id)">
                        <img v-if="data.messageType === 'success'" src="../public/img/base-message-field/icon_close_message_success.svg" />
                        <img v-else-if="data.messageType === 'error' || data.messageType === 'unpaid'" src="../public/img/base-message-field/icon_close_message_error.svg" />
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>
<style scoped>
    /* この画面だけのスタイルを上書きする */
    .message-field-wrapper {
        position: fixed;
        top: 20px;
        right: 24px;
        z-index: 9999;
    }
    .message-field {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 320px;
        background: #ffffff;
        box-shadow: 0px 4px 8px rgb(154 185 205 / 30%);
        border-radius: 8px;
        padding: 16px 24px 16px 16px;
        margin-bottom: 10px;
        margin-left: auto;
    }
    .message-field__left {
        flex: 1;
        display: flex;
        justify-content: flex-start;
    }
    .message-field__left .icon {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        position: relative;
    }
    .message-field__left .icon img {
        position: absolute;
        top: 2px;
        left: 0;
    }

    .message-field__left .content {
        max-width: 230px;
    }
    .message-field__left .content .title,
    .message-field__left .content .message {
        line-height: 18px;
        white-space: pre-wrap;
        font-family: 'noto-sans-cjk-jp';
        font-weight: normal;
        font-style: normal;
        font-size: 12px;
    }
    .message-field__left .content .title {
        margin-bottom: 3px;
        font-family: 'noto-sans-cjk-jp';
        font-weight: 800;
    }
    .message-field__right .icon-close {
        cursor: pointer;
    }
    .message-field.error .message-field__left {
        color: #d82d4c;
    }
    .message-field.unpaid .message-field__left {
        color: #d82d4c;
    }
    .message-field.success .message-field__left {
        color: #139cab;
    }
    .list-enter-active,
    .list-leave-active {
        transition: all 1s;
    }
    .list-enter {
        opacity: 0;
        transform: translateY(-30px);
    }
    .list-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
</style>
